export enum FileType {
  File = 0,
  SurveyFile = 1,
}
